/* eslint-disable import/prefer-default-export */
import _isEmpty from 'lodash/isEmpty';
import * as types from '../constants/ActionTypes';
import { contactPage, suggestTopics, chatBotContactTo, chatBotQueryParams } from '../constants/UtilVariables';
import { fetchPhoneNumber } from './action-call-us';
import getTopicTree from '../../home/actions/action-topic-list';
import { accessLogoutEmail } from './action-email-no-intent';
import { fetchTopicTree } from '../actions/action-message-topic-tree';
import { fetchRelatedTopic } from './action-quick-answer-topics';
import { isLoggedIn, getLogoutEmailRefId, getChatBotContactTo, isAUPHardcodeFormEnabled, getQueryParamValue } from '../../lib/page';
import { fetchPPCEnable } from './action-ppc-checker';
import { fetchChatBotSessionChecker } from './action-chat-bot';
import { providePPMEmailFields } from './action-paypalme-email';


export const redirecLocation = ({ pageName }) => ({
  type: types.CONTACT_LOCATION_CHANGE,
  payload: { pageName },
});

// Fetch data for Call Page
function fetchCallPageRequests(chatBotParams) {
  return (dispatch) => {
    dispatch(fetchPhoneNumber(chatBotParams));

    if (isLoggedIn()) {
      dispatch(fetchPPCEnable());
    }
  };
}

// fetch data for Email Page
function fetchEmailPageRequests(options) {
  return (dispatch) => {
    // Using Hardcode webform data for PayPalMe controlled by remote config
    if (isAUPHardcodeFormEnabled()) {
      dispatch(providePPMEmailFields());
    } else {
      dispatch(fetchTopicTree(options));
    }

    dispatch(getTopicTree());
    dispatch(fetchRelatedTopic(suggestTopics.email));
  };
}

// Redirect to Call or Email page based on current pageName
function redirectToCallOrEmail(pageName) {
  return (dispatch) => {
    if (pageName === contactPage.callUs) {
      dispatch(fetchCallPageRequests()); // Fetch data for Call Us
    } else if (pageName === contactPage.email) {
      dispatch(fetchEmailPageRequests({ email: true })); // Fetch data for Email Page
    } else {
      // Loading Topic tree data in the Contact landing page
      dispatch(fetchTopicTree());
    }
  };
}

function checkChatBotSession(redirect = {}) {
  return (dispatch) => {
    const chatBotQueryRedirectParam = getChatBotContactTo();
    const chatBotParams = {};

    if (chatBotQueryRedirectParam && chatBotQueryRedirectParam === chatBotContactTo.call) {
      chatBotParams.topic_code = getQueryParamValue(chatBotQueryParams.TOPIC_CODE);
      chatBotParams.topic_key = getQueryParamValue(chatBotQueryParams.TOPIC_KEY);
    }
    // Login and chatBot checker
    if (!chatBotQueryRedirectParam || !isLoggedIn()) {
      return redirect.default(); // default redirect logic
    }

    const chatBotSessionChecker = responseData => (
      (responseData && !_isEmpty(responseData.chatState)
    && responseData.chatState.conversationId
      )
    );

    // Redirect to Call or Email page for ChatBot;
    const options = {};
    options.callBack = (responseData) => {
      const chatBotConversationId = chatBotSessionChecker(responseData);
      if (!responseData || !chatBotConversationId) {
        return redirect.default(); // default redirect
      } else if (chatBotContactTo.email === chatBotQueryRedirectParam) {
        return redirect.email(); // Email redirect
      } else if (chatBotContactTo.call === chatBotQueryRedirectParam) {
        chatBotParams.chatbot = chatBotConversationId;
        return redirect.callUs(chatBotParams); // Call redirect
      }
      return redirect.default(); // default redirect if the chatBotQuery is not validate
    };

    return dispatch(fetchChatBotSessionChecker(options));
  };
}

// Check Current location and send API request for different locations
export const locationChecker = () => (dispatch, getState) => {
  const state = getState();
  const { location: { pageName } } = state;

  // query checker for logout Email; have validate refId for `email` query
  const emailRef = getLogoutEmailRefId();
  if (emailRef) {
    // Redirect to Logout WebForm
    dispatch(redirecLocation({ pageName: contactPage.email }));
    dispatch(fetchEmailPageRequests({ emailRef, logoutEmail: true }));
    dispatch(accessLogoutEmail());
  } else {
    // ChatBot redirect switcher
    const redirect = {
      default: () => {
        // if pageName is undefined which is initial state then redirect the location to contactUs home.
        // else redirect to appropriate page location.
        if (pageName === undefined) {
          dispatch(redirecLocation({ pageName: contactPage.contactUs }));
          dispatch(redirectToCallOrEmail(contactPage.contactUs));
        } else {
          dispatch(redirectToCallOrEmail(pageName));
        }
      },
      email: () => {
        dispatch(redirecLocation({ pageName: contactPage.email }));
        dispatch(fetchEmailPageRequests({ email: true }));
      },
      callUs: (chatBotParams) => {
        dispatch(redirecLocation({ pageName: contactPage.callUs }));
        dispatch(fetchCallPageRequests(chatBotParams));
      },
    };

    // Check chatBot query and chatBot session data.
    // Based on the chatBot session response redirect to appropriate channel.
    dispatch(checkChatBotSession(redirect));
  }

  return {
    type: types.CONTACT_LOCATION_LOAD,
  };
};

// Update current location action, if users go to Email/CallUs page/Channel Steering
export const locationUpdate = ({ pageName }) => (dispatch) => {
  if (pageName) {
    dispatch(redirecLocation({ pageName }));
    dispatch(locationChecker());
  }
};
